import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWrenchRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.361 5.818a3.818 3.818 0 0 1 5.535-3.411.543.543 0 0 1 .14.873l-1.675 1.675v.684h.684l1.675-1.675a.55.55 0 0 1 .473-.153.54.54 0 0 1 .4.294 3.818 3.818 0 0 1-3.411 5.534c-.377 0-.743-.055-1.089-.157l-3.99 3.986a1.819 1.819 0 0 1-2.57-2.57l3.985-3.991a3.8 3.8 0 0 1-.157-1.089m3.819-2.727a2.727 2.727 0 0 0-2.528 3.754.54.54 0 0 1-.12.591L3.3 11.668a.728.728 0 0 0 1.03 1.03l4.23-4.232a.55.55 0 0 1 .591-.12 2.726 2.726 0 0 0 3.716-2.989l-1.211 1.211a.55.55 0 0 1-.386.16H9.816a.544.544 0 0 1-.546-.546V4.727c0-.145.057-.284.16-.386l1.21-1.211a3 3 0 0 0-.46-.04" })
});
export default SvgWrenchRegularIcon;
